import {Component, Input, OnInit} from '@angular/core';
import {FormModel} from "../shared/forms/models/constants";
import {PropertyFormComponent} from "./properties/property-form/property-form.component";
import {PropertyService} from "../shared/forms/services/property.service";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {TranslateService} from "@ngx-translate/core";
import {PrimeTemplate} from "primeng/api";
import {SplitterModule} from "primeng/splitter";
import {Router} from "@angular/router";
import {NgIf} from "@angular/common";
import {PropertiesComponent} from "./properties/properties.component";
import {environment} from "../../environments/environment";
import {CookieService} from "ngx-cookie-service";
import {UserService} from "../shared/services/user.service";

@Component({
    selector: 'app-admin',
    standalone: true,
    imports: [
        PrimeTemplate,
        SplitterModule,
        NgIf,
        PropertiesComponent
    ],
    providers: [PropertyService],
    templateUrl: './admin.component.html',
    styleUrl: './admin.component.scss'
})
export class AdminComponent implements OnInit {

    @Input() formName!: string;
    @Input() formLabel!: string;
    @Input() formId!: string;
    @Input() formValues!: FormModel[];

    token: any;
    id: string = "";

    propertyLabel: string | undefined;
    propertyKey: string | undefined;
    ref!: DynamicDialogRef;
    selected: string = "default";

    constructor(public dialogService: DialogService,
                public translate: TranslateService,
                private propertyService: PropertyService,
                private router: Router,
                private userService: UserService,
                private cookieService: CookieService) {

    }

    ngOnInit(): void {
        this.token = this.cookieService.get('access_token');
        if (!this.formName) {
            this.formName = this.formId;
        }
        if (!this.formLabel) {
            this.formLabel = '' + this.formId;
        }

        this.router.events.subscribe(event => {
            //console.log(event);
        });
    }

    navigateTo(page: string) {
        this.selected = page;
        //this.router.navigate([{ outlets: { admin: [page] } }]);
    }


    showPropertyForm() {


        this.ref = this.dialogService.open(PropertyFormComponent, {
            header: "",
            width: '70%',
            data: {
                propertyKey: this.formId,
                propertyLabel: this.translate.instant(this.formLabel),
            },

        });
        this.ref.onClose.subscribe(value => {
            if (value) {
                this.propertyService.getPropertyListByKey(this.formId).then(data => this.formValues = data);
            }
        });
    }

    editProfile() {
        console.log("edit starts.");
        window.location.href = `${environment.editUrl}/${this.token}`;
    }

    async onEdit2faSettings() {
        const user = await this.userService.getCurrentUser().then(value => {return value});
        window.location.href = `${environment.twoFactorUrl}/${user.id}/${this.token}`;
    }
    async editGroups() {
        const user = await this.userService.getCurrentUser().then(value => {return value});
        window.location.href = `${environment.groupsUrl}/${this.token}`;
    }
}
